import { PaymentWebhookEventListPage } from "@/features/payment-webhook-event/pages/PaymentWebhookEventListPage";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/admin/payment-webhook-event/")({
	beforeLoad({ context }) {
		if (
			!context.authAdapter.can({
				permissions: ["it.monitoring.payment_transaction"],
			})
		) {
			throw redirect({ to: "/403" });
		}
	},
	component: PaymentWebhookEventListPage,
});
